/**
 * The type of the response form the server
 *
 * @public
 */
export enum ResponseType {
	/**
	 * Raw text which needs formatting before parsing
	 */
	RAW = 'RAW',
	/**
	 * Refined content which can be parsed without reformatting
	 */
	REFINED = 'REFINED'
}
